import ArtTrack from '@material-ui/icons/ArtTrack';
import classNames from 'classnames';
import _ from 'lodash';
import { observer } from 'mobx-react';
import moment from 'moment';
import React from 'react';
import LinesEllipsis from 'react-lines-ellipsis';
import responsiveHOC from 'react-lines-ellipsis/lib/responsiveHOC';
import * as TELEMETRY from '../App/Constants/Telemetry';
import { TileStatus } from '../App/Constants/TileStatus';
import DashboardStore from '../App/Stores/DashboardStore';
import AuthorizationStore from '../App/Stores/AuthorizationStore';
import Tile from './Tile';
import StreamArticle from '../App/Models/StreamArticle';

interface Props {
  authorizationStore: AuthorizationStore;
  dashboardStore: DashboardStore;
  title: string;
  loadData: Function;
  initialStatus?: TileStatus;
}

@observer
class NewsStream extends Tile<Props> {
  constructor(props: Props) {
    super(props);
  }

  handleEventsClick = (article: StreamArticle) => {
    window.telemetry.logEvent(TELEMETRY.EVENTS.DASHBOARD_NEWS_STREAM);
    this.props.dashboardStore.updateSelectedArticle(article)
  }

  getThumb(article: StreamArticle){
    let url;
    if(article.ThumbnailMedia ){
      url = window.appSettings.aemStreamContentUrl + article.ThumbnailMedia._path; 
    } else if(article.ExternalThumbnailMedia){
      url = article.ExternalThumbnailMedia._path;
    } else {
      url = '';
    }
    return url;
  }

  render() {

    const { dashboardStore } = this.props;
    const ResponsiveEllipsis = responsiveHOC()(LinesEllipsis);

    if (dashboardStore!.newsArticlesStatus === TileStatus.LOADED || dashboardStore!.newsArticlesCurrentPage > 1) {
      return (
        <>
          {dashboardStore!.newsArticles.map(article =>{  
            const thumb = this.getThumb(article);         
            const hero = article.heroMedia != null ? article.heroMedia : article.externalHeroMedia;
            const first = article.firstMedia != null ? article.firstMedia : article.externalFirstMedia;
            const second = article.secondMedia != null ? article.secondMedia : article.externalSecondMedia;
            const third = article.thirdMedia != null ? article.thirdMedia : article.externalThirdMedia;
            const fourth = article.fourthMedia != null ? article.fourthMedia : article.externalFourthMedia;
            return (
              <div className="c-dashboard__tile-stream-news-card" key={article.id}>                
                <div className={classNames('c-dashboard__tile-stream-news-image', _.isEmpty(thumb) ? 'no-thumbnail' : '')}>
                <a target="_blank" onClick={() => this.handleEventsClick(article)}>
                    <img src={thumb} />
                  </a>
                </div>
                <div className="c-dashboard__tile-stream-news-info">
                  <div className={classNames('c-dashboard__tile-stream-news-info-title-content', _.isEmpty(article.Title) ? 'no-summary' : '')}>
                    <span className="c-dashboard__tile-stream-news-info-header-title">
                    <a target="_blank" onClick={() => this.handleEventsClick(article)}>
                        {article.Title}
                      </a>
                    </span>
                  </div>
                  <div className={classNames('c-dashboard__tile-stream-news-info-content', _.isEmpty(article.Summary.html) ? 'no-summary' : '')}>
                    <ResponsiveEllipsis
                      className="c-dashboard__tile-stream-news-info-content-text"
                      text={article.Summary.plaintext ? article.Summary.plaintext : ''}
                      maxLine="4"
                      ellipsis="..."
                    />
                  </div>
                  <div className="c-dashboard__tile-stream-news-info-footer">
                    <span>
                      {moment(article.PublishDate).format('D MMM YYYY')}
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
        </>
      );
    } else {
      return super.render();
    }

  }
}

export default NewsStream;